import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';

const Icon = () => (
    <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.10938 0C6.09375 0 6.95312 0.164062 7.6875 0.492188C8.40625 0.835938 9 1.28906 9.46875 1.85156C9.9375 2.41406 10.2891 3.07031 10.5234 3.82031C10.7578 4.57031 10.875 5.36719 10.875 6.21094C10.875 7.89844 10.625 9.42188 10.125 10.7812C9.60938 12.1562 8.94531 13.3672 8.13281 14.4141C7.32031 15.4766 6.42188 16.3828 5.4375 17.1328C4.4375 17.8984 3.45312 18.5078 2.48438 18.9609L1.80469 18.0469C3.17969 16.75 4.27344 15.5938 5.08594 14.5781C5.89844 13.5781 6.30469 12.7422 6.30469 12.0703C6.30469 11.6641 6.13281 11.3359 5.78906 11.0859C5.44531 10.8359 5.02344 10.6094 4.52344 10.4062C4.03906 10.2188 3.53125 10.0078 3 9.77344C2.46875 9.53906 1.98438 9.22656 1.54688 8.83594C1.09375 8.46094 0.726562 7.98438 0.445312 7.40625C0.148438 6.82812 0 6.09375 0 5.20312C0 4.67188 0.109375 4.10156 0.328125 3.49219C0.53125 2.88281 0.851562 2.32031 1.28906 1.80469C1.71094 1.28906 2.24219 0.859375 2.88281 0.515625C3.52344 0.171875 4.26562 0 5.10938 0ZM18 0C18.9844 0 19.8438 0.164062 20.5781 0.492188C21.2969 0.835938 21.8906 1.28906 22.3594 1.85156C22.8281 2.41406 23.1797 3.07031 23.4141 3.82031C23.6484 4.57031 23.7656 5.36719 23.7656 6.21094C23.7656 7.89844 23.5156 9.42188 23.0156 10.7812C22.5 12.1562 21.8359 13.3672 21.0234 14.4141C20.2109 15.4766 19.3125 16.3828 18.3281 17.1328C17.3281 17.8984 16.3438 18.5078 15.375 18.9609L14.6953 18.0469C16.0703 16.75 17.1641 15.5938 17.9766 14.5781C18.7891 13.5781 19.1953 12.7422 19.1953 12.0703C19.1953 11.6641 19.0234 11.3359 18.6797 11.0859C18.3359 10.8359 17.9141 10.6094 17.4141 10.4062C16.9297 10.2188 16.4219 10.0078 15.8906 9.77344C15.3594 9.53906 14.875 9.22656 14.4375 8.83594C13.9844 8.46094 13.6172 7.98438 13.3359 7.40625C13.0391 6.82812 12.8906 6.09375 12.8906 5.20312C12.8906 4.67188 13 4.10156 13.2188 3.49219C13.4219 2.88281 13.7422 2.32031 14.1797 1.80469C14.6016 1.28906 15.1328 0.859375 15.7734 0.515625C16.4141 0.171875 17.1562 0 18 0Z"
            fill="#E6E6E7"
        />
    </svg>
);
export default function TheComp() {
    const { t } = useLang('aboutus.H');

    const item = [
        {
            title: t('list1'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767701692850-ww8mup-compressed-1-image.jpg',
        },
        {
            title: t('list2'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767701732366-yuwo8e-compressed-2-image.jpg',
        },
        {
            title: t('list3'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767701749150-lzl08d-compressed-3-image.jpg',
        },
    ];

    return (
        <section id="about-us-I" className={`about-us-I ${css.section} GtmModuleData-section`} data-section-id="About-Us-I">
            <div className="list-container">
                <div className="title-info">{t('title')}</div>
                <div className="list">
                    {item.map((i, index) => (
                        <div className="item" key={index}>
                            <div className="img-box">
                                <EcoImg pc={i.pc} className="comp-bg" />
                            </div>
                            <div className="text-box">
                                <div className="item-title">{i.title}</div>
                                <div className="icon">
                                    <Icon />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
